import { Button, IconButton, IconFilters16 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { useIsFiltersRedesign } from '../../../context';

interface IFilterButtonProps {
  hasActiveFilters?: boolean;
  onClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void;
}

export const FiltersButton = ({ hasActiveFilters = false, onClick }: IFilterButtonProps) => {
  const isRedesign = useIsFiltersRedesign();

  return (
    <span
      className={cn(
        styles['filters-button'],
        hasActiveFilters && styles['filters-button_active'],
        isRedesign && styles['filters-button_redesign'],
      )}
    >
      {isRedesign ? (
        /*
         * Button size="XS" без children — это ровно 36x36 с радиусом 8, а тема main_secondary
         * даёт тот же голубой, что и у кнопки поиска из микрофронта.
         */
        <Button
          theme="main_secondary"
          size="XS"
          beforeIcon={<IconFilters16 color="icon-main-default" />}
          onClick={onClick}
        />
      ) : (
        <IconButton icon={<IconFilters16 color="primary_100" />} onClick={onClick} />
      )}
    </span>
  );
};
